// extracted by mini-css-extract-plugin
export default {"collapse":"PackingMaking_collapse__YmcgZ"};